module.exports = __webpack_public_path__ + "img/background004.9da5e36d.jpg";